import ImageWithText from './ImageWithText';
import Parallax from '../global/Parallax';
import { createClickableSection } from '../modules/sectionLink';

export default class ImageWithTextOverlay extends ImageWithText {
  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   * @param {boolean} pageLoad
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.theme = theme;
    this.element = element;
    this.sectionWrapper = /** @type {HTMLElement} */ (this.element.querySelector('.homepage-featured-content-wrapper'));
    this.imageWrapper   = /** @type {HTMLElement} */ (this.element.querySelector('.homepage-content--image'));
    this.contentWrapper = /** @type {HTMLElement} */ (this.element.querySelector('.homepage-featured-content-box-inner'));
    this.imageElement   = this.imageWrapper.getElementsByTagName('img').item(0);
    this.sectionHeightSetToOriginal = this.element.classList.contains('size-original');

    if(this.sectionHeightSetToOriginal) {
      this.setToOriginalHeight();
    }

    this.parallax = new Parallax(this.theme, this.element);
    createClickableSection(this.element);
  }

  onWindowResize = () => {
    if(this.sectionHeightSetToOriginal) {
      this.setToOriginalHeight();
    }
  }

  setToOriginalHeight = () => {
    this.setImageWrapperHeight('auto');

    if(this.contentIsTallerThanImage()) {
      this.toggleCoverClass('true');
      this.setImageWrapperHeight('100%');
    } else {
      this.toggleCoverClass();
      this.setSectionMinHeight();
    }
  }

  toggleCoverClass = (contentIsTaller) => {
    if(!this.imageElement) return;

    this.imageElement.classList.remove('image-cover');

    if(contentIsTaller) this.imageElement.classList.add('image-cover');
  }

  setImageWrapperHeight = (value) => {
    this.imageWrapper.style.height = value;
  }

  setSectionMinHeight = () => {
    this.sectionWrapper.style.minHeight = `${this.getImageHeight()}px`;
  }

  getContentHeight = () => {
    return this.contentWrapper.offsetHeight;
  }

  getImageHeight = () => {
    return this.imageWrapper.offsetHeight;
  }

  contentIsTallerThanImage = () => {
    return this.getContentHeight() > this.getImageHeight();
  }
}
